(function(angular) {
	angular.module('bizPartEngage').controller('modules.missions', missionsController);
	angular.module('bizPartEngage').controller('modules.missions.view', missionsViewController);
	angular.module('bizPartEngage').controller('modules.missions.users', missionsUsersController);

	missionsController.$inject = ["modules.missions.service", "$stateParams", "$interval", "$translate", "MetadataService"];
	missionsViewController.$inject = ["modules.missions.service", "$stateParams", "$translate", "MetadataService"];
	missionsUsersController.$inject = ["modules.missions.service", "$stateParams", "$translate", "MetadataService"];

	function missionsController(missionsService, $stateParams, $interval, $translate, MetadataService) {
    	var vm = this;
    }

	function missionsViewController(missionsService, $stateParams, $translate, MetadataService) {
    	var vm = this;
    	vm.Mission = {};
    	vm.MissionId = ~~$stateParams.id;
    	vm.GetMission = GetMission;
    	vm.GetRuleUrl = GetRuleUrl;

    	function GetRuleUrl(rule) {
			var url = rule.Value.Url.Value;
    		if (rule.Value.CompleteId && url != null && url.indexOf("#OBJECTID#") > -1)
				url = url.replace("#OBJECTID#", rule.Value.CompleteId.Value.Id);
				
			if (rule.Value.CompleteId && url != null && url.indexOf("#URLREWRITE#") > -1)
    			url = url.replace("#URLREWRITE#", rule.Value.CompleteId.Value.UrlRewrite);

    		return url;
    	}

    	function GetMission(missionId) {
			missionsService.GetMission(missionId).then(getMissionCallBack);

    		function getMissionCallBack(response) {
    			 var mission = response.data;
    			 for (var i = 0; i < mission.Rules.length; i++) {
    			 	mission.Rules[i].Value = JSON.parse(mission.Rules[i].Value);
    			}
    			vm.Mission = mission;
    		}
    	}

    	angular.element(document).ready(function () {
    	    vm.GetMission(vm.MissionId);

    	    $translate(['MISSIONS.META.TITLE', 'MISSIONS.META.DESCRIPTION']).then(function (translations) {
    	        MetadataService.setMetaTags({
    	            title: translations['MISSIONS.META.TITLE'],
    	            description: translations['MISSIONS.META.DESCRIPTION']
    	        })
    	    });
    	});
    }

	function missionsUsersController(missionsService, $stateParams, $translate, MetadataService) {
    	var vm = this;
    	vm.Users = [];
    	vm.MissionId = ~~$stateParams.id;
    	vm.GetUsers = GetUsers;
    	vm.Back = Back;

    	function GetUsers() {
			missionsService.GetUsers(vm.MissionId).then(function (response) {
    			vm.Users = response.data;
    		});
    	}

    	function Back() {
    		window.history.back();
    	}

    	angular.element(document).ready(function () {
    	    vm.GetUsers();

    	    $translate(['MISSIONS.META.TITLE', 'MISSIONS.META.DESCRIPTION']).then(function (translations) {
    	        MetadataService.setMetaTags({
    	            title: translations['MISSIONS.META.TITLE'],
    	            description: translations['MISSIONS.META.DESCRIPTION']
    	        })
    	    });
    	});
    }
})(window.angular);
